"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _i18n = require("@active/react-utils/i18n");
var ModalHeader = function ModalHeader(props, ref) {
  var i18n = props.i18n,
    title = props.title,
    onClose = props.onClose,
    onCloseKeyDown = props.onCloseKeyDown,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: "modal-header"
  }, children || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "modal-title"
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    role: "button",
    ref: ref,
    className: "modal-close icon-btn icon-btn-dim",
    tabIndex: 0,
    "aria-label": i18n('react-ui.modal.ariaLabel.closeDialog'),
    onClick: onClose,
    onKeyDown: onCloseKeyDown
  })));
};
var Composed = (0, _i18n.withI18n)((0, _compose["default"])(_react["default"].forwardRef)(ModalHeader));
var _default = exports["default"] = Composed;